import { HelpContent } from '../../../../UI-Lib/Help-Tooltip';

export const ASSET_LIMIT_HELP: HelpContent[] = [
    {
        helpContentId: 'asset-limit.header',
        tooltipText: '',
        hasIcon: false
    }
];
